var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPackage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.25 15.0628V9.43783L1.5 6.68783V12.3128L6.25 15.0628ZM7.75 15.0628L12.5 12.3337V6.70866L7.75 9.43783V15.0628ZM6.25 16.8128L0.75 13.6253C0.5125 13.4881 0.328125 13.3071 0.196875 13.0824C0.0656249 12.8578 0 12.6082 0 12.3337V5.66699C0 5.39241 0.0656249 5.14283 0.196875 4.91824C0.328125 4.69352 0.5125 4.51255 0.75 4.37533L6.25 1.18783C6.48792 1.04894 6.7384 0.979492 7.00146 0.979492C7.26438 0.979492 7.51389 1.04894 7.75 1.18783L13.25 4.37533C13.4875 4.51255 13.6719 4.69352 13.8031 4.91824C13.9344 5.14283 14 5.39241 14 5.66699V12.3337C14 12.6082 13.9344 12.8578 13.8031 13.0824C13.6719 13.3071 13.4875 13.4881 13.25 13.6253L7.75 16.8128C7.51208 16.9517 7.2616 17.0212 6.99854 17.0212C6.73563 17.0212 6.48611 16.9517 6.25 16.8128ZM10.1667 6.29199L11.8958 5.31283L6.97917 2.50033L5.3125 3.47949L10.1667 6.29199ZM7 8.12533L8.70833 7.14616L3.77083 4.35449L2.10417 5.31283L7 8.12533Z",
    fill: "#A1A1A1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPackage);
export default __webpack_public_path__ + "static/media/package.fb13fd38fbb90f88a7ba098c506d58fe.svg";
export { ForwardRef as ReactComponent };